//path: src\features\sceneName\sceneNameReducer.ts

import {
  SET_SCAN_FILE_NAME,
  SET_SCAN_UPLOADED,
  SceneNameActionTypes
} from './sceneNameActions';

// State Type
interface SceneNameState {
  experience: string | undefined;
  rawExperienceName: string | undefined;
  scanFileName?: string; // Make this optional if it's not set initially
  scanUploaded?: boolean; // Make this optional if it's not set initially
}

// Initial State
const initialState: SceneNameState = {
  experience: undefined,
  rawExperienceName: undefined,
  scanFileName: undefined, // or you could initialize as null if that suits your application logic
  scanUploaded: undefined // or set it to false if that makes sense for your app flow
};

const sceneNameReducer = (
  state: SceneNameState = initialState,
  action: SceneNameActionTypes
): SceneNameState => {
  switch (action.type) {
    case SET_SCAN_FILE_NAME:
      return {
        ...state,
        scanFileName: action.payload.scanFileName
      };
    case SET_SCAN_UPLOADED:
      return {
        ...state,
        scanUploaded: action.payload.scanUploaded
      };
    default:
      return state;
  }
};

export default sceneNameReducer;
